import AuthService from '../../../services/AuthService'
import { SET_LOADING, SET_AUTH_STATE_VALUE, SET_AUTHORIZATION_ID } from './variables'
import { sessionStatuses } from '../../../constants'
import { i18n } from '../../../language/i18n'

const state = {
  loading: false,
  errorMessage: '',
  sessionStatus: sessionStatuses.Closed,
  expiresTime: 0,
  authorizationId: null
}

const mutations = {
  [SET_LOADING]: (state, value) => {
    state.loading = value
  },
  [SET_AUTH_STATE_VALUE]: (state, value) => {
    state[value[0]] = value[1]
  },
  [SET_AUTHORIZATION_ID]: (state, value) => {
    state.authorizationId = value
  },
}

const getters = {
  isAuth: state => state.sessionStatus === sessionStatuses.Authorized,
  sessionStatus: state => state.sessionStatus,
  loading: state => state.loading,
  expiresTime: state => (state.expiresTime / 60).toFixed(0),
  authorizationId: state => state.authorizationId
}

const actions = {
  async startSession({ commit, dispatch, rootGetters }, payload) {
    commit(SET_LOADING, true)
    commit(SET_AUTH_STATE_VALUE, ['sessionStatus', sessionStatuses.Pending])
    try {
      const successUrl = `${window.location.origin}/${i18n.locale}/account`
      const failureUrl = window.location.origin + window.location.pathname
      const data = {
        bankId: payload.bankId,
        brand: payload.brand,
        successUrl,
        failureUrl,
        country: rootGetters['personal/selectedCountry'],
        psu_type: rootGetters['personal/selectedPsuType']
      }
      const response = await AuthService.startSession(data)
      if (response && response.data.response.url) {
        commit(SET_AUTHORIZATION_ID, response.data.response.authorization_id)
        return true
      }
    } catch (error) {
      const errorMessage = (error.response && error.response.data.message) || error
      dispatch('base/pushAlertMessage', { message: errorMessage }, { root: true })
      return false
    } finally {
      commit(SET_LOADING, false)
    }
  },
  async getSessionStatus({ commit, dispatch }) {
    try {
      const session = await AuthService.getSessionStatus()
      const status = session.data.response && session.data.response.status
      const expiresTime = session.data.response && session.data.response.expires
      if (status === sessionStatuses.Invalid) {
        dispatch(
          'base/pushAlertMessage',
          { message: i18n.tc('authenticationFailure') },
          { root: true })
      }
      if (status) {
        commit(SET_AUTH_STATE_VALUE, ['expiresTime', expiresTime])
        commit(SET_AUTH_STATE_VALUE, ['sessionStatus', status])
      }
    } catch (error) {
      commit(SET_AUTH_STATE_VALUE, ['sessionStatus', sessionStatuses.Closed])
    }
  },
  async closeSession({ dispatch, commit }) {
    commit(SET_LOADING, true)
    try {
      const session = await AuthService.closeSession()
      const response = session.data.response

      if (response.message === 'OK') {
        commit(SET_AUTH_STATE_VALUE, ['sessionStatus', sessionStatuses.Closed])
      }
    } catch (error) {
      if (error.response &&
          error.response.status === 422 &&
          error.response.data &&
          error.response.data.detail &&
          error.response.data.detail.find(d =>
            d.loc[0] === 'cookie' &&
            d.loc[1] === 'sessionid' &&
            d.type === 'value_error.missing')) {
        return
      }
      dispatch('base/pushAlertMessage', { message: error }, { root: true })
    } finally {
      commit(SET_LOADING, false)
    }
  }
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
